/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'm9.7 5.2 1.5 1.4-3.6 3.5c-.3.4 0 .9.4.9h12.9v2H8c-.5 0-.7.5-.4.8l3.4 3.5-1.4 1.4L3 11.9l6.7-6.7Z',
  DEV ? 'ArrowBackIcon' : '',
  '',
  true,
);
